import PageHeading from '../../shared/components/UIElements/PageHeading';
import EmptyState from '../../shared/components/UIElements/EmptyState';
import React, { useEffect, useState, useContext } from 'react';
import { AuthContext } from '../../shared/Context/auth-context';
import ErrorModal from '../../shared/components/UIElements/ErrorModal';
import LoadingSpinner from '../../shared/components/UIElements/LoadingSpinner';
import { useHttpClient } from '../../shared/hooks/http-hook';
import './PatientHistory.css';
import { BACKEND_URL } from '../../shared/util/backend-url';

const UserHistory = () => {
  const { patientId, token } = useContext(AuthContext);
  const { isLoading, error, sendRequest, clearError } = useHttpClient();
  const [history, setHistory] = useState([]);

  useEffect(() => {
    const fetchHistory = async () => {
      try {
        const responseData = await sendRequest(
          `${BACKEND_URL}/api/patient/${patientId}`,
          'GET',
          null,
          {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + token
          }
        );
        setHistory(responseData.history);
      } catch (err) {
        console.error(err);
      }
    };
    if (patientId) {
      fetchHistory();
    }
  }, [sendRequest, patientId, token]);

  return (
    <React.Fragment>
      <ErrorModal error={error} onClear={clearError} />
      <div className="user-history-container">
        <PageHeading
          eyebrow="YOUR CARE JOURNEY"
          title="Medical history"
          description="A record of your consultations, prescriptions, and treatment notes."
        />
        {isLoading && <LoadingSpinner asOverlay />}
        {!isLoading && history.length === 0 && (
          <EmptyState icon="history" title="Your care journey starts here">
            Your consultation and prescription history will appear here.
          </EmptyState>
        )}
        {!isLoading && history.length > 0 && (
          <ul className="history-list">
            {history.map((item, index) => (
              <li key={index} className="history-card">
                <p>
                  <strong>Condition:</strong> {item.condition}
                </p>
                <p>
                  <strong>Medication:</strong>
                </p>
                <ul>
                  {item.medication && item.medication.length > 0 ? (
                    item.medication.map((med, i) => (
                      <li key={i}>
                        {med.name} ({med.dose}) – {med.duration}, {med.frequency}
                      </li>
                    ))
                  ) : (
                    <li>N/A</li>
                  )}
                </ul>
                <p>
                  <strong>Remarks:</strong> {item.remarks || 'N/A'}
                </p>
                <p>
                  <strong>Doctor:</strong> {item.doctorName} ({item.doctorEmail})
                </p>
                <p>
                  <strong>Date:</strong> {new Date(item.createdAt).toLocaleString()}
                </p>
              </li>
            ))}
          </ul>
        )}
      </div>
    </React.Fragment>
  );
};

export default UserHistory;
